import React, { useState } from 'react';
import { toast } from 'sonner';
import { Send, Check, Loader2 } from 'lucide-react';
import { CrmContactSelect } from '../CrmContactSelect';

export const SummaryNoteTest = ({ api, agentId, s }) => {
  const [contact, setContact] = useState(null);
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState('');

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/api/agents/${agentId}/test-summary-note`, { contact_id: contact.id });
      setPreview(data.note);
      toast.success(`Test note added to ${contact.name || 'contact'} in your CRM`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Failed to send test note');
    } finally { setSending(false); }
  };

  return (
    <div className={`mt-5 pt-5 border-t ${s.cardBorder} space-y-3`} data-testid="summary-note-test">
      <p className={`text-xs font-medium ${s.textSecondary}`}>Send a test note to a CRM contact</p>
      <CrmContactSelect api={api} fetchUrl={`/api/agents/${agentId}/crm-contacts`} contact={contact} onSelect={c => { setContact(c); setPreview(''); }} s={s} testId="summary-note-contact" />
      <button onClick={send} disabled={!contact || sending} data-testid="summary-note-send-test-btn"
        className={`px-4 py-2.5 rounded-xl text-sm font-medium transition-colors inline-flex items-center gap-2 ${contact ? 'bg-teal-400/10 text-teal-500 border border-teal-400/20 hover:bg-teal-400/20' : `${s.inputBg} border ${s.cardBorder} ${s.textSecondary} opacity-50 cursor-not-allowed`}`}>
        {sending ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Send Test Note
      </button>
      {preview && (
        <div data-testid="summary-note-preview">
          <p className="flex items-center gap-1 text-xs text-green-500 mb-1.5"><Check size={12} /> Posted to CRM notes</p>
          <pre className={`whitespace-pre-wrap text-xs leading-relaxed p-3 rounded-xl ${s.inputBg} border ${s.cardBorder} ${s.textPrimary} font-sans`}>{preview}</pre>
        </div>
      )}
    </div>
  );
};
